import { IPermissionModel } from './';

export const RCIPermissions: IPermissionModel[] = [
	{
		name: 'Dashboard',
		route: '/',
		components: [
			'user-sufficiency-summary',
			'focus-products',
			'attendance-check',
			'total-out-off-view',
			'total-out-off-view-site',
			'total-site-leads-from-kae',
			'total-competition-site-visited',
			'total-site-visited',
			'power-BI',
			'member-module',
			'meeting-banner',
			'quarter-summary',
			'dashboard-banner',
			'dashboard-competition-conversion',
			'dashboard-birthday-popup',
		],
	},
	{ name: 'Profile', route: '/profile', components: [] },
	{ name: 'StructureQuestionnaires', route: '/structured-questionnaires', components: [] },
	{ name: 'Jharokha', route: '/jharokha', components: [] },
	{ name: 'Meetings', route: '/meetings', components: [] },
	{ name: 'TodaysMeetings', route: '/meetings/todays-meetings', components: [] },
	{ name: 'AllMeetings', route: '/meetings/all-meetings', components: [] },
	{ name: 'FccCarnivalMeet', route: '/meetings/fcc-meetings', components: [] },
	{ name: 'TodayMeetings', route: '/today-meetings', components: [] },
	{ name: 'AttendanceDetails', route: '/today-meetings/attendance-details', components: [] },
	{ name: 'MeetingsConducted', route: '/meetings-conducted', components: ['bde-meeting-fields'] },
	{ name: 'ExpenseDetails', route: '/meetings-conducted/expense-details', components: [] },
	{ name: 'CompletedRecord', route: '/meetings-conducted/completed-record', components: [] },
	{ name: 'MeetingDetails', route: '/meeting-details', components: [] },
	{ name: 'ManageParticipants', route: '/meeting-details/manage-participants', components: [] },
	{ name: 'AddNewMeeting', route: '/add-new-meeting', components: ['imr-dropdown', 'bde-meeting-fields'] },
	{ name: 'ManageParticipants', route: '/add-new-meeting/manage-participants', components: [] },
	{ name: 'EditMeeting', route: '/edit-meeting', components: ['imr-dropdown', 'bde-meeting-fields'] },
	{ name: 'ManageParticipants', route: '/edit-meeting/manage-participants', components: [] },
];
